import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Title from '../../components/Title';
import useMainProgressContext from '../../components/progress/MainProgress/context/MainProgressContext';

const Dashboard: FC = () => {
  const { t } = useTranslation();
  const { hide } = useMainProgressContext();

  useEffect(() => {
    hide();
  }, []);

  return <Title>{t('dashboard.title')}</Title>;
};

export default Dashboard;
